import React from "react";

export const TeaserCard = ({ icon: Icon, glyph, title, children, subtext, cta, onCta, testid, ctaTestid, extra }) => (
  <div data-testid={testid} className="bg-white border border-[#e5e7eb] rounded-2xl p-5 shadow-sm h-full flex gap-3">
    <span className="w-10 h-10 shrink-0 rounded-lg flex items-center justify-center bg-paper border border-gold text-gold font-bold">
      {Icon ? <Icon className="w-5 h-5" /> : glyph}
    </span>
    <div className="flex flex-col min-w-0 flex-1">
      <h3 className="font-semibold text-ink">{title}</h3>
      <div className="mt-1 text-sm text-ink-muted leading-relaxed flex-1">{children}</div>
      {subtext && <p className="mt-2 text-[11px] text-[#9ca3af]">{subtext}</p>}
      <button type="button" data-testid={ctaTestid} onClick={onCta} className="mt-3 self-start text-[12px] font-semibold text-gold hover:underline">
        {cta}
      </button>
      {extra}
    </div>
  </div>
);
